<div class="line-dashboard-wrapper fw fh">
    <app-dashboard-filter-header dashboardName="{{'menu.line_db' | translate}}"
        (applyFilter)='fliterChange($event, "applyBtn")'></app-dashboard-filter-header>
    <div class="no-line-text fw" *ngIf="showNoFilterMsg">{{'line_db.no_filter' | translate}}</div>
    <div class="no-line-text fw" *ngIf="!showNoFilterMsg && noMachines">{{'line_db.no_machine' | translate}}</div>
    <div class="grid-wrapper" *ngIf="!showNoFilterMsg">
        <mat-grid-list cols="12" gutterSize="24" rowHeight="355px" *ngIf="!showNoFilterMsg">
            <mat-grid-tile *ngFor="let item of machineList; let i = index" colspan="3">
                <div class="fw fh tile-content">
                    <div class="top">
                        <div class="header">
                            <div class="left fh">
                                <div class="machine-name ellipses " title="{{item?.name}}">
                                    <span>{{item?.name}}</span>
                                </div>

                                <div class="fiveWiH add" (click)="openDialog(item)" (keydown.enter)="openDialog(item)"
                                    (keydown.space)="openDialog(item)">
                                    <span>5W1H</span>
                                </div>

                            </div>
                            <div class="sequence-dtls">
                                <div class="serial-no fh">
                                    <span>{{item?.sequenceNumber}}</span>
                                </div>
                                <div class="sequence-info">
                                    <span>{{'line_db.order_number' | translate}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bottom">
                        <div class="comparison-area"
                            *ngIf="item?.totalMachineWaste && (unitSelected === 'cost' || unitSelected === 'wastePer')">
                            <div class="bar total" [ngClass]="{'hide-me':!showInGraph?.total}"
                                [style.height]="item?.totalMachineWaste > 0 ? ((item?.totalMachineWaste*100)/highestWaste)+'%' : '0%' "
                                @fillUp>
                            </div>
                            <div class="bar rmw" [ngClass]="{'hide-me':!showInGraph?.RM}"
                                [style.height]="item?.rmWaste > 0 ? ((item?.rmWaste*100)/highestWaste)+'%' : '0%' "
                                @fillUp>
                            </div>
                            <div class="bar pw" [ngClass]="{'hide-me':!showInGraph?.PM}"
                                [style.height]="item?.packageWaste > 0 ? ((item?.packageWaste*100)/highestWaste)+'%' : '0%' "
                                @fillUp>
                            </div>
                        </div>
                        <div class="no-waste"
                            *ngIf="!(item?.rmWaste || item?.packageWaste) && (unitSelected === 'cost' || unitSelected === 'wastePer')">
                            <span>{{'waste_db.no_waste' | translate}}</span>
                        </div>
                        <div class="quantity-comparison-area" *ngIf="unitSelected === 'quantity'">
                            <app-line-stacked-bar-chart [graphData]="item" style="
                            height: 100%;"></app-line-stacked-bar-chart>
                        </div>
                        <div class="waste-values" *ngIf="unitSelected === 'cost' || unitSelected === 'wastePer'">
                            <div class="total-waste value-wrapper" [hidden]="!showInGraph?.total">
                                <div class="legend"></div>
                                <div class="unit" [ngClass]="[currencyData?.currencyValueCode =='eu' ? 'euro' : '',
                                                currencyData?.currencyValueCode =='eus' ? 'euro_static' : '',
                                                currencyData?.currencyValueCode =='ru' ? 'ruble' : '',
                                                currencyData?.currencyValueCode =='ars' ? 'ars' : '',
                                                currencyData?.currencyValueCode =='cop' ? 'cop' : '',
                                                currencyData?.currencyValueCode =='ves' ? 'ves' : '',
                                                currencyData?.currencyValueCode =='svc' ? 'svc' : '',
                                                currencyData?.currencyValueCode =='crc' ? 'crc' : '',
                                                currencyData?.currencyValueCode =='usd' ? 'usd' : '',
                                                currencyData?.currencyValueCode =='bob' ? 'bob' : '',
                                                currencyData?.currencyValueCode =='hnl' ? 'hnl' : '',
                                                currencyData?.currencyValueCode =='mxn' ? 'mxn' : '',
                                                currencyData?.currencyValueCode =='clp' ? 'clp' : '',
                                                currencyData?.currencyValueCode =='brl' ? 'brl' : '']">
                                </div>
                                <div class="value total ellipses"
                                    title="{{item?.totalMachineWaste | localDecimalPipe}}">
                                    <span>{{item?.totalMachineWaste | currencyRateFormatter:currencyData?.currencyRate |
                                        localDecimalPipe}}</span>
                                </div>
                            </div>
                            <div class="raw-material-waste value-wrapper" [hidden]="!showInGraph?.RM">
                                <div class="legend"></div>
                                <div class="unit" [ngClass]="[currencyData?.currencyValueCode =='ru' ? 'ruble' : '',
                                                currencyData?.currencyValueCode =='eu' ? 'euro' : '',
                                                currencyData?.currencyValueCode =='cop' ? 'cop' : '',
                                                currencyData?.currencyValueCode =='eus' ? 'euro_static' : '',
                                                currencyData?.currencyValueCode =='svc' ? 'svc' : '',
                                                currencyData?.currencyValueCode =='ars' ? 'ars' : '',
                                                currencyData?.currencyValueCode =='usd' ? 'usd' : '',
                                                currencyData?.currencyValueCode =='ves' ? 'ves' : '',
                                                currencyData?.currencyValueCode =='hnl' ? 'hnl' : '',
                                                currencyData?.currencyValueCode =='crc' ? 'crc' : '',
                                                currencyData?.currencyValueCode =='clp' ? 'clp' : '',
                                                currencyData?.currencyValueCode =='bob' ? 'bob' : '',
                                                currencyData?.currencyValueCode =='brl' ? 'brl' : '',
                                                currencyData?.currencyValueCode =='mxn' ? 'mxn' : '']"></div>
                                <div class="value rmw ellipses" title="{{item?.rmWaste | localDecimalPipe}}">
                                    <span>{{item?.rmWaste | currencyRateFormatter:currencyData?.currencyRate |
                                        localDecimalPipe}}</span>
                                </div>
                            </div>
                            <div class="package-material-waste value-wrapper" [hidden]="!showInGraph?.PM">
                                <div class="legend"></div>
                                <div class="unit" [ngClass]="[currencyData?.currencyValueCode =='eu' ? 'euro' : '',
                                                currencyData?.currencyValueCode =='ru' ? 'ruble' : '',
                                                currencyData?.currencyValueCode =='eus' ? 'euro_static' : '',
                                                currencyData?.currencyValueCode =='svc' ? 'svc' : '',
                                                currencyData?.currencyValueCode =='cop' ? 'cop' : '',
                                                currencyData?.currencyValueCode =='ars' ? 'ars' : '',
                                                currencyData?.currencyValueCode =='crc' ? 'crc' : '',
                                                currencyData?.currencyValueCode =='ves' ? 'ves' : '',
                                                currencyData?.currencyValueCode =='usd' ? 'usd' : '',
                                                currencyData?.currencyValueCode =='clp' ? 'clp' : '',
                                                currencyData?.currencyValueCode =='hnl' ? 'hnl' : '',
                                                currencyData?.currencyValueCode =='bob' ? 'bob' : '',
                                                currencyData?.currencyValueCode =='mxn' ? 'mxn' : '',
                                                currencyData?.currencyValueCode =='brl' ? 'brl' : '']"></div>
                                <div class="value pw ellipses" title="{{item?.packageWaste | localDecimalPipe}}">
                                    <span>{{item?.packageWaste | currencyRateFormatter:currencyData?.currencyRate |
                                        localDecimalPipe}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-grid-tile>
        </mat-grid-list>
    </div>
</div>